module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-block"
  }, [_c('h3', {
    staticClass: "card-title"
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 card-stat"
  }, [_c('loading-indicator')], 1)]) : _c('div', {
    staticClass: "row"
  }, [(_vm.isTeamSuspend) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-icon alert-danger alert-dismissible p-30",
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-11 clearfix"
  }, [_c('div', {
    staticClass: "pull-xs-left"
  }, [_c('h3', {
    staticClass: "red-600 m-0 p-0"
  }, [_c('i', {
    staticClass: "icon md-notifications"
  }), _vm._v(_vm._s(_vm.$t("suspend.labels.suspend")))]), _vm._v(" "), (this.team.suspend.suspend_reason) ? _c('p', {
    staticClass: "p-l-40 m-0"
  }, [_vm._v(_vm._s(this.team.suspend.suspend_reason))]) : _c('p', {
    staticClass: "p-l-40 m-0"
  }, [_vm._v(_vm._s(_vm.$t("suspend.labels.defaultMessage")))])])]), _vm._v(" "), (!this.team.suspend.suspend_reason) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('a', {
    staticClass: "btn btn-danger btn-lg pull-xs-right",
    attrs: {
      "href": "#addcreditSection"
    }
  }, [_vm._v(_vm._s(_vm.$t("billing.action.addCredit")))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showCurrentCredit) ? _c('div', [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "pricing-list pricing-credit text-xs-left m-b-0 card-stat"
  }, [_c('div', {
    staticClass: "pricing-header",
    class: (_vm.balances.credit >= 0) ? 'bg-blue-600' : 'bg-red-600'
  }, [_c('div', {
    staticClass: "pricing-title"
  }, [_vm._v(_vm._s(_vm.$t("billing.labels.remainingCredits")))]), _vm._v(" "), _c('div', {
    staticClass: "pricing-price"
  }, [_c('span', {
    staticClass: "pricing-amount"
  }, [_vm._v(_vm._s(_vm.balances.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), (_vm.showLastAddedCredit) ? _c('p', {
    staticClass: "p-x-30 p-b-25"
  }, [_vm._v(_vm._s(_vm.$t("currentCredit.lastedTransaction")) + " : " + _vm._s(_vm.balances.latest_refill_transaction.human_credit) + " " + _vm._s(_vm.$t("billing.currencies.thb")) + " " + _vm._s(_vm.$t("text.on")) + " " + _vm._s(_vm.latestRefillDate) + " ")]) : _c('p', {
    staticClass: "p-x-30 p-b-25"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("currentCredit.textGuide")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "bg-blue-grey-100 p-30 card-stat"
  }, [_c('div', {
    staticClass: "counter counter-md text-xs-left"
  }, [_c('div', {
    staticClass: "counter-label text-uppercase m-b-5"
  }, [_vm._v(_vm._s(_vm.$t("billing.labels.currentMonthUsage")) + "\n              "), (_vm.showDiscount && (_vm.team.discount > 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t("billing.labels.perfixDiscount")) + " " + _vm._s(_vm.team.discount) + "% " + _vm._s(_vm.$t("billing.labels.subfixDiscount")) + ")")]) : _vm._e(), _vm._v(" "), (_vm.showDiscount && (_vm.team.discount <= 0)) ? _c('span', [_vm._v("(" + _vm._s(_vm.$t("billing.labels.noDiscount")) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "counter-number-group m-b-10"
  }, [_c('span', {
    staticClass: "counter-number"
  }, [_vm._v(_vm._s(_vm.humanTotalCost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])]), _vm._v(" "), _c('div', {
    staticClass: "counter-label"
  }, [_c('div', {
    staticClass: "progress progress-xs m-b-10"
  }, [_c('div', {
    staticClass: "progress-ba r progress-bar-info",
    class: (_vm.usagePercentage <= 80) ? 'bg-primary' : 'bg-danger',
    style: ({
      width: _vm.usagePercentage + '%'
    }),
    attrs: {
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  }, [_vm._v("\n                 \n                ")])]), _vm._v(" "), (_vm.showUsagePercentage) ? _c('div', {
    staticClass: "counter counter-sm text-xs-left m-t-30"
  }, [(_vm.usagePercentage < 100) ? _c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number",
    class: (_vm.usagePercentage <= 80) ? 'blue-600' : 'red-600'
  }, [_vm._v(_vm._s(_vm.usagePercentage) + "%")]), _vm._v(" "), _c('span', {
    staticClass: "counter-number-related"
  }, [_vm._v(_vm._s(_vm.$t("currentCredit.percentageBar")))])]) : _vm._e(), _vm._v(" "), (_vm.usagePercentage >= 100) ? _c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number red-600"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.creditNotEnough")))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "counter-number-group m-t-10"
  }, [_c('span', {
    staticClass: "counter-number-related"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.nextCreditCharge")) + " : " + _vm._s(_vm.upcomingBillDate) + " ("), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#statementSection'),
      expression: "'#statementSection'"
    }],
    staticClass: "btn btn-link p-0",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.$t("title.statement")))]), _vm._v(")")])])]) : _c('div', {
    staticClass: "counter counter-sm text-xs-left m-t-30"
  }, [_c('div', {
    staticClass: "counter-number-group"
  }, [_c('span', {
    staticClass: "counter-number-related"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.textGuide"))), (_vm.balances.latest_bill_id) ? _c('span', [_vm._v("("), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#statementSection'),
      expression: "'#statementSection'"
    }],
    staticClass: "btn btn-link p-0",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.$t("title.statement")))]), _vm._v(")")]) : _vm._e()])])])])])])])]) : _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "p-30 bg-primary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "font-size-24 m-b-5"
  }, [_vm._v(_vm._s(_vm.$t("billing.labels.currentMonthUsage")))]), _vm._v(" "), (_vm.balances.upcoming_bill ? _vm.balances.upcoming_bill.total_cost > 0 : false) ? _c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.nextCreditCharge")) + ": " + _vm._s(_vm.upcomingBillDate) + " ("), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#statementSection'),
      expression: "'#statementSection'"
    }],
    staticClass: "btn btn-link p-0",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.$t("statement.action.statement")))]), _vm._v(")")])]) : _c('div', [_c('div', {
    staticClass: "font-size-14"
  }, [_vm._v(_vm._s(_vm.$t("monthToDateCost.textGuide")) + " "), (_vm.balances.latest_bill_id) ? _c('span', [_vm._v("("), _c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#statementSection'),
      expression: "'#statementSection'"
    }],
    staticClass: "btn btn-link p-0",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v(_vm._s(_vm.$t("statement.action.statement")))]), _vm._v(")")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "counter counter-lg text-xs-right"
  }, [_c('span', {
    staticClass: "counter-number white"
  }, [_vm._v(_vm._s(_vm.humanTotalCost) + " " + _vm._s(_vm.$t("billing.currencies.thb")))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12400989!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/CurrentStat.vue
// module id = 505
// module chunks = 1